export const COOKIE_ECHO_USER = 'cookie-echo-user';